import React from 'react';
import * as msgpub from "msgpub";
import {TextArea, ButtonG, Heading} from '../Common';
import { Box, Select, TextInput } from 'grommet';
import { HeaderStyleForGrommet, MainStyleForGrommet } from '../../constant/Styles';
import { anyCallBackFunction, getListStr, searchText } from '../../common/AdminMqtt';
import { DisabelesAdminContext } from '../../constant/AdminMqtt';
import { status_mapper } from '../../common/common';



export default function TopicComponent(props: {admin?: msgpub.Admin, getTopics: any, setLog: any}) {
    const {admin, setLog} = props;
    const [topicList, setTopicList] = React.useState<Array<string>>([]); // 全体結果
    const [searchedTopicList, setSearchedTopicList] = React.useState<Array<string>>([]); // 検索に引っかかった結果
    const [topicForAdd, setTopicForAdd] = React.useState('');
    const [topicForRemove, setTopicForRemove] = React.useState('');
    const disables = React.useContext(DisabelesAdminContext);
    const [topicListStr, setTopicListStr] = React.useState<string>(''); // 全体結果

    const getTopics = () => {
        anyCallBackFunction(setTopicList,
                            setSearchedTopicList,
                            setLog,
                            admin?.setTopicInfoCallback.bind(admin),
                            admin?.getTopics.bind(admin),
                            "getTopics"
        );
    };

    const getTopicsStr = () => {
        getListStr(setTopicListStr, setLog, admin?.setTopicInfoCallback.bind(admin), admin?.getTopics.bind(admin), "getTopics");
    }

    const onChangeForTopicAdd = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTopicForAdd(event.target.value);
    }

    const addTopic = () => {
        admin?.addTopic({
            topic: topicForAdd,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[addTopic func]status: " + status_mapper(status) + "\n"));
            }
        });
    }

    const removeTopic = () => {
        admin?.removeTopic({
            topic: topicForRemove,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[removeTopic func]status: " + status_mapper(status) + "\n"));
            }
        });
    }

    return (
        <div>
            <Box {...HeaderStyleForGrommet}>
                <Heading title="topic control"/>
            </Box>
            <Box {...MainStyleForGrommet}>
                <form>
                    <TextInput placeholder="new topic" value={topicForAdd} onChange={onChangeForTopicAdd} disabled={disables.others}/>
                    <ButtonG name="add" callback={addTopic} disabled={disables.others} />
                </form>
            </Box>
            <Box {...MainStyleForGrommet}>
                <form>
                    <Select
                        placeholder="select topic"
                        value={topicForRemove}
                        onSearch={input => {searchText(input, topicList, setSearchedTopicList)}}
                        onChange={(event) => {
                            setTopicForRemove(event.value);
                        }}
                        onOpen={getTopics}
                        options={searchedTopicList}
                        disabled={disables.others}
                    />
                    <ButtonG name="delete" callback={removeTopic} disabled={disables.others}/>
                </form>
            </Box>
            <TextArea texts={topicListStr} name="topic list" disabled={disables.others} id="topic-list" onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setTopicListStr(e.target.value)}}/>
            <ButtonG name="get topics" callback={getTopicsStr} disabled={disables.others} />
        </div>
    );
}
